module.exports = __webpack_public_path__ + "img/icon_warning_black.eb21c254.svg";